var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form-row',{attrs:{"model-items":_vm.modelItems,"all-parametrs":{ disabled: true }}})}
var staticRenderFns = []

export { render, staticRenderFns }